
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("ResetPassword: Starting password reset process for:", email);
    setIsLoading(true);
    
    try {
      const { data, error } = await supabase.auth.resetPasswordForEmail(email);
      console.log("ResetPassword: Reset password response:", { data, error });

      if (error) {
        console.error("ResetPassword: Error during reset:", error);
        throw error;
      }
      
      console.log("ResetPassword: Reset email sent successfully");
      toast({
        title: "Email envoyé",
        description: "Vérifiez votre boîte mail pour réinitialiser votre mot de passe.",
      });
      
      navigate("/account");
    } catch (error: any) {
      console.error("ResetPassword: Caught error:", error);
      toast({
        title: "Erreur",
        description: error.message || "Une erreur est survenue lors de la réinitialisation du mot de passe.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-md">
      <h1 className="text-2xl font-bold mb-6">Réinitialisation du mot de passe</h1>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-2">
            Adresse email
          </label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votreemail@exemple.com"
            required
            className="w-full"
          />
        </div>
        
        <Button type="submit" className="w-full" disabled={isLoading}>
          {isLoading ? "Envoi en cours..." : "Réinitialiser le mot de passe"}
        </Button>

        <p className="text-sm text-gray-600 text-center mt-4">
          Vous vous souvenez de votre mot de passe ?{" "}
          <a
            href="/account"
            className="text-primary hover:underline"
          >
            Retour à la connexion
          </a>
        </p>
      </form>
    </div>
  );
};

export default ResetPassword;
